/**
 * @fileoverview Data model to hold the backend response after requesting a list of saved filters.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */
import {SavedFilterOption, SavedFilterOptionJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/selectentities/data/savedfilteroption';

export class GetSavedFiltersResponse {
  /**
   * @param {{
   *   options: !Array<!SavedFilterOption>,
   * }} params
   */
  constructor(params) {
    /** @type {!Array<!SavedFilterOption>} */
    this.options = params.options;
  }

  /**
   * @param {!GetSavedFiltersResponseJson} json
   * @return {!GetSavedFiltersResponse}
   */
  static fromJSON(json) {
    return new GetSavedFiltersResponse({
      options: json['options'].map(SavedFilterOption.fromJSON),
    });
  }
}

/**
 * @dict
 * @typedef {{
 *   options: !Array<!SavedFilterOptionJson>,
 * }}
 */
export let GetSavedFiltersResponseJson;
